// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"55":"4dd37a5e","161":"a4cd8664","408":"b79056d5","563":"4e8be6a9","819":"bcbd6a5d"}[chunkId] + ".js";
};